import template from './socialSecurityData.html';
import './socialSecurityData.scss';

let socialSecurityDataComponent = {
  restrict: 'E',
  bindings: {
    text : '@',
  },
  template
};

export default socialSecurityDataComponent;



// WEBPACK FOOTER //
// ./client/app/social-security.module/components/socialSecurityCard/socialSecurityData/socialSecurityData.component.js